import Vue from 'vue';

Vue.filter('addOne', val => {
  let output = Number(val);
  output += 1;
  return output;
});

Vue.filter('getIndexedImage', (val, index) => val[index]);

Vue.filter('formatBytes', (a, b) => {
  const c = 1024;
  const d = b || 2;
  const e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const f = Math.floor(Math.log(a) / Math.log(c));
  if (a === 0) return '0 Bytes';
  return `${parseFloat((a / (c ** f)).toFixed(d))} ${e[f]}`;
});

Vue.filter('textCase', (value, theme) => {
  // Ignore case in theme variable
  theme = theme.toLowerCase();

  if (!value || !['gmhba', 'frank'].includes(theme)) return value;
  if (theme === 'frank') return value.toLowerCase();
  return value;
});



// WEBPACK FOOTER //
// ./src/utils/filters/index.js